import { render, staticRenderFns } from "./Etapas.vue?vue&type=template&id=1efc2c1f"
import script from "./Etapas.vue?vue&type=script&lang=js"
export * from "./Etapas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports